var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDjango(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_371_566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00192 0.0012207C13.9907 0.0239107 18.0396 4.00978 17.9996 9.07721C17.9614 13.9919 14.0235 18.07 8.84844 18.0023C3.98897 17.9371 -0.0739181 14.0081 0.00102038 8.83339C0.0709149 4.00582 3.97924 0.0217497 9.00192 0.0012207ZM7.78525 6.52333C7.28814 6.41196 6.77393 6.39973 6.27207 6.48731C5.20096 6.67063 4.36763 7.19503 3.91764 8.2186C3.58329 8.97853 3.5397 9.77556 3.71588 10.5794C3.94249 11.6145 4.58272 12.2722 5.59366 12.5855C6.16759 12.7627 6.75521 12.8243 7.35147 12.8153C8.14667 12.799 8.93846 12.7065 9.716 12.5391V3.58984H7.78525V6.52333ZM10.8711 6.58384C10.8711 6.91518 10.8754 7.23212 10.8711 7.55014C10.8484 9.06749 10.9334 10.5863 10.8051 12.1018C10.7287 13.0022 10.3959 13.7629 9.57729 14.239C9.38778 14.3496 9.19035 14.4468 8.9695 14.5631L10.7569 15.4113C11.654 15.0512 12.2581 14.4083 12.5561 13.5082C12.7759 12.8441 12.8083 12.154 12.8123 11.4654C12.8234 9.90486 12.8159 8.34465 12.8159 6.78336V6.58204L10.8711 6.58384ZM12.8083 3.61433H10.8826V5.57539H12.8083V3.61433Z",
    fill: "#007987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77931 8.11029V11.1716C7.0501 11.3902 6.2038 11.1716 5.87414 10.6829C5.4908 10.1153 5.5207 9.04958 5.93503 8.51871C6.30648 8.04186 7.10774 7.8607 7.77931 8.11029Z",
    fill: "#007987"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/Django.1972088f8e93a1c0c4b65c0058ff2327.svg";
export { ForwardRef as ReactComponent };